import { FC, ReactNode, useEffect } from "react";
import { useAppSelector } from "@/store/hooks";
import { useNavigate } from "react-router";
import { ROUTES } from "@/route/routes.constants";
import { normalizeAppReturnPath, POST_LOGIN_REDIRECT_STORAGE_KEY } from "@/lib/auth/post-login-redirect";

interface WithAuth {
    children: ReactNode;
}

export const WithAuth: FC<WithAuth> = ({ children }) => {
    const token = useAppSelector(state => state.auth.token);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            const returnPath = `${window.location.pathname}${window.location.search}`;
            if (returnPath && returnPath !== ROUTES.ROOT) {
                sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, normalizeAppReturnPath(returnPath));
            }
            navigate(ROUTES.ROOT);
        }
    }, [navigate, token]);
    return (
        <>
            {children}
        </>
    );
};
